// ChatBanner.js - Optimized banner component
import React from 'react';

const ChatBanner = ({ 
  message = "Messages disappear after 24 hours", 
  showBanner = true, 
  onClose 
}) => {
  if (!showBanner) return null;
  
  return (
    <div style={{
      width: 'calc(100% - 24px)',
      margin: '12px auto 8px',
      padding: '10px 14px',
      backgroundColor: 'rgba(0, 0, 0, 0.21)',
      backdropFilter: 'blur(10px)',
      WebkitBackdropFilter: 'blur(10px)',
      color: 'white',
      fontSize: '0.9375rem',
      lineHeight: '1.4',
      textAlign: 'center',
      position: 'relative',
      borderRadius: '0',
      border: '1px solid rgba(55, 65, 81, 0.2)',
      boxShadow: '0 1px 3px rgba(0, 0, 0, 0.1)',
      display: 'flex',
      justifyContent: 'center',
      alignItems: 'center',
      zIndex: 10
    }}>
      <span style={{ 
        maxWidth: 'calc(100% - 20px)'
      }}>
        {message}
      </span>
      <button
        onClick={onClose}
        style={{
          background: 'none',
          border: 'none',
          color: '#9ca3af',
          cursor: 'pointer',
          padding: '4px',
          position: 'absolute',
          right: '8px',
          fontSize: '16px',
          fontWeight: 'bold',
          display: 'flex',
          alignItems: 'center',
          justifyContent: 'center',
          width: '20px',
          height: '20px',
          borderRadius: '0',
          transition: 'background-color 0.2s'
        }}
        aria-label="Close banner"
      >
        ×
      </button>
    </div>
  );
};

export default ChatBanner; 